import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AuthGuard } from '../guard/auth.guard';
import { MobileGuard } from '../guard/mobile.guard';
import { NewsGuard } from '../guard/news.guard';
import { TrendGuard } from '../guard/trend.guard';
import * as jwt_decode from 'jwt-decode';

@Injectable()
export class ConfigService {

  configURL = 'assets/config/config.json';
  appConfig: any;

  constructor(
    private http: HttpClient
  ) {
    if (window.Cypress) {
      console.log('ConfigService running Cypress');
      window.ConfigService = this;
    }
  }

  loadAppConfig() {
    return this.http.get(this.configURL)
      .toPromise()
      .then(data => {

        // enabling longer data history for admins on prod
        // let startDate = null;
        // const token = localStorage.getItem('token');
        // if (token) {
        //   const user = jwt_decode(token);
        //   if (user.roles.includes('ADMIN') && (data['environment'] === 'prod')) {
        //     startDate = '2015-01-01';
        //   }
        // }

        this.appConfig = {
          version: data['version'],
          environment: data['environment'],
          production: data['production'],
          urlDataApi: data['urlDataApi'],
          urlMetadataApi: data['urlMetadataApi'],
          urlCustomerApi: data['urlCustomerApi'],
          urlQuantApi: data['urlQuantApi'],
          urlNewsletterApi: data['urlNewsletterApi'],
          urlSentry: data['urlSentry'],
          routing: {
            name: data['routing']['name'],
            theme: data['routing']['theme'],
            apiproj: data['routing']['apiproj'],
            authpro: data['routing']['authpro'],
            project: data['routing']['project'],
          },
          setup: {
            // startDate: startDate ? startDate : data['startDate']
            startDate: data['startDate']
          }
        };

        this.appConfig.guards = {
          project: [],
          cockpit: [MobileGuard, AuthGuard],
          news: [NewsGuard],
          trend: [TrendGuard],
          mobile: [AuthGuard],
          iframe: [AuthGuard],
        };

      });
  }

  isScorelab() {
    return this.appConfig && (this.appConfig.routing.project === 'scorelab');
  }

}
